import {
  Title,
  Text,
  Container,
  SimpleGrid,
  ThemeIcon,
  rem,
} from "@mantine/core";
import { IconBodyScan, IconBrain, IconLeaf } from "@tabler/icons-react";
import classes from "./holisticIntro.module.scss";

const pillars = [
  {
    icon: IconBodyScan,
    title: "Kropp",
    description:
      "Kosthold, bevegelse og søvn er grunnmuren. Glem kaloritelling, kjøkkenvekt og straffetrening — for de fleste handler det om noen få, smarte endringer i hverdagen som gir overraskende stor uttelling.",
  },
  {
    icon: IconBrain,
    title: "Sinn",
    description:
      "Varig helse starter i hodet. Når vi endrer perspektivene, tankemønstrene og rutinene dine, blir sunne valg noe du gjør fordi du vil — ikke fordi du må. Gode vaner som til slutt går på autopilot.",
  },
  {
    icon: IconLeaf,
    title: "Livsstil",
    description:
      "Stress, inneklima, skjermtid, søvnrytme og relasjoner påvirker helsen din mer enn de fleste aner. Jeg ser på hele livssituasjonen din — ikke bare det som skjer på kjøkkenet og på gymmen.",
  },
];

export function HolisticIntro() {
  return (
    <section className={classes.section}>
      <Container size="lg">
        <div className={classes.header}>
          <span className={classes.label}>Helhetlig coaching</span>
          <Title order={2} className={classes.title}>
            Hva er helhetlig coaching?
          </Title>
          <Text className={classes.subtitle}>
            De fleste coacher gir deg én oppskrift: spis mindre, tren mer. Jeg
            ser på kroppen som ett sammenkoblet system — der søvn, stress,
            kosthold og tankemønstre påvirker hverandre. Når brikkene faller på
            plass, kommer resultatene nesten av seg selv.
          </Text>
        </div>

        <SimpleGrid
          cols={{ base: 1, md: 3 }}
          spacing={40}
          className={classes.grid}
        >
          {pillars.map((pillar) => (
            <div key={pillar.title} className={classes.pillar}>
              <ThemeIcon
                size={72}
                radius="xl"
                variant="gradient"
                gradient={{ deg: 135, from: "teal", to: "green" }}
                className={classes.icon}
              >
                <pillar.icon
                  style={{ width: rem(36), height: rem(36) }}
                  stroke={1.5}
                  aria-hidden="true"
                />
              </ThemeIcon>
              <Title order={3} className={classes.pillarTitle}>
                {pillar.title}
              </Title>
              <Text c="white" fz="sm" className={classes.pillarDescription}>
                {pillar.description}
              </Text>
            </div>
          ))}
        </SimpleGrid>

        <div className={classes.divider} />
      </Container>
    </section>
  );
}
